/**
 * Design-system tokens for chart layout spacing.
 * All fixed-pixel values were calibrated for landscape (800x520).
 */

import { CANVAS_REF_WIDTH, CANVAS_REF_HEIGHT } from '../../config/constants';

// ─── Title spacing ──────────────────────────────────────────────────────────
export const TITLE_SPACING = {
  topInset: 12,
  titleToContentGap: 28,
  noTitleTopPad: 20,
};

// ─── Legend spacing ─────────────────────────────────────────────────────────
export const LEGEND_SPACING = {
  rowHeight: 26,
  topOffset: 22,
  baseTopSpace: 28,
  bottomGap: 50,
  rightGap: 15,
  rightItemHeight: 26,
  rectSize: 14,
  rectTextX: 20,
  markerSize: 7,
  lineMarkerSize: 5,
  lineLength: 30,
  lineTextX: 36,
  markerTextX: 20,
  textDy: 4,
  itemGap: 16,
};

// ─── Canvas scale reference ─────────────────────────────────────────────────
const REF_W = CANVAS_REF_WIDTH;
const REF_H = CANVAS_REF_HEIGHT;

/**
 * Proportional scaling factors so margins shrink on smaller canvases
 * and grow (up to a cap) on larger ones.
 */
export function canvasScale(width, height) {
  return {
    w: Math.max(0.45, Math.min(1.3, width / REF_W)),
    h: Math.max(0.45, Math.min(1.3, height / REF_H)),
  };
}
